/* unplugin-vue-components disabled */import script from "./message-face.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-face.vue?vue&type=script&lang=ts&setup=true"

import "./message-face.vue?vue&type=style&index=0&id=bdccb2b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdccb2b4"]])

export default __exports__